import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import useAuth from 'contexts/auth/useAuth';
import { useCreateOrganizationMutation } from 'store/api/knowledge-hub/organization.api';

export function useCheckOwnOrganization() {
  const {
    auth: { setCompany },
  } = useDispatch();
  const { company } = useAuth();
  const [createOrganization] = useCreateOrganizationMutation();

  useEffect(() => {
    if (company && !company.ownOrganizationId) {
      createOrganization({
        organization: {
          name: company.name,
          url: company.url,
          isOwnOrganization: true,
        },
      })
        .unwrap()
        .then((organization) => {
          setCompany({
            ...company,
            ownOrganizationId: organization.id,
          });
        });
    }
  }, [company, createOrganization, setCompany]);
}
